import React from 'react'
import StatCard from '@/pages/admin/dashboard/components/StatCard'
import { formatNumber } from '@/utils/formatText'

const KPICards = ({
    statItems,
    isLoading
}) => {

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-3">

            {/* Render KPI/stat cards in a responsive grid */}
            {statItems.map((s, idx) => (
                <StatCard
                    key={`${s.label}-${idx}`}
                    label={s.label}
                    value={isLoading ? "…" : formatNumber(s.value)}
                    metaIdx={s.metaIdx}
                    loading={isLoading}
                    route={s.route}
                    icon={s.icon}
                    query={s.query}
                />
            ))}
        </div>
    )
}

export default KPICards